import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as _ from 'lodash';
import * as moment from 'moment';
import { combineLatest, map, takeUntil } from 'rxjs';
import { FeedbackService } from 'src/app/core/services/feedback.service';
import { BaseComponent } from './../../../../core/components/base/base.component';
import { PatientCommunicationService } from './../../../../core/services/patient-communication.service';
import { PatientNoteService } from './../../../../core/services/patient-note.service';

@Component({
  selector: 'app-patient-media-list',
  templateUrl: './patient-media-list.component.html',
  styleUrls: ['./patient-media-list.component.scss']
})
export class PatientMediaListComponent extends BaseComponent {
  @Input() initialExpanded?: boolean;
  expanded?: boolean;
  @Output() expandedChange = new EventEmitter<boolean>();

  patientMedia?: any[] | null;

  constructor(
    private patientNoteService: PatientNoteService,
    private patientCommunicationService: PatientCommunicationService,
    private cd: ChangeDetectorRef,
    fs: FeedbackService,
    md: MatDialog
  ) {

    super(fs, md);

    combineLatest([
      this.patientNoteService.patientMedia$.pipe(map(noteMedia => noteMedia ?? [])),
      this.patientCommunicationService.patientMedia$.pipe(map(communicationMedia => communicationMedia ?? []))
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([noteMedia, communicationMedia]) => {
        const combined = _.orderBy([...noteMedia, ...communicationMedia], [(media) => moment(media.createdAt), 'displayIndex'], ['asc', 'desc']);
        this.patientMedia = [...combined];
        this.cd.markForCheck()
      });
  }

  toggleExpanded() {
    this.expanded = !this.expanded;
    this.expandedChange.emit(this.expanded);
  }

}
